module.exports = __webpack_public_path__ + "img/code.8a8db5b3.jpg";